<template>
  <div class="banner-container">
    <base-card
      dark
      :to="lift.is_redirectable ? null : { path: lift.path}"
      :href="lift.is_redirectable ? lift.url : null"
      :target="lift.is_redirectable ? '_blank' : null"
      :rel="lift.is_redirectable ? 'noreferrer' : null"
    >
      <tk-media
        class="grey lighten-2"
        width="100%"
        :sizes="sizes"
        :height="height"
        :aspect-ratio="aspectRatio"
        :media="bannerMedia"
        :style="{'background-color': bannerMedia.color }"
      ></tk-media>
    </base-card>

    <base-card
      class="banner-inner"

      :class="{
      'container fluid mx-auto py-0': noAction,
      'px-3': noAction && !$vuetify.breakpoint.mdAndUp,
      'px-4': noAction && $vuetify.breakpoint.mdAndUp,
      'banner-inner--mobile-no-action pb-5 pt-3': noAction && $vuetify.breakpoint.smAndDown,
      }"
      :style="noAction && $vuetify.breakpoint.smAndDown ? {backgroundColor: lift.bg_color, color: lift.text_color} : undefined"
      :to="lift.is_redirectable ? null : { path: lift.path}"
      :href="lift.is_redirectable ? lift.url : null"
      :target="lift.is_redirectable ? '_blank' : null"
      :rel="lift.is_redirectable ? 'noreferrer' : null"
    >
      <!-- Check if at least title present -->
      <div
        v-if="lift.title && !noAction"
        :class="{
          'mx-auto': $vuetify.breakpoint.smAndUp,
          'banner-inner-content--mobile': $vuetify.breakpoint.smAndDown
        }"
        class="banner-inner-content text-xs-center"
        :style="{backgroundColor: lift.bg_color, color: lift.text_color}"
      >

        <div
          :class="{'my-3':$vuetify.breakpoint.mdAndUp}"
          v-if="title"
        >
          <h1
            class="font-weight-medium font-miller-display"
            v-html="title"
          ></h1>
        </div>

        <tk-btn
          v-if="btn_title"
          dark
          :style="{backgroundColor: lift.btn_bg_color, color: lift.btn_text_color}"
          class="banner-inner__btn"
          :class="{'mt-1 banner-inner__btn--mobile': $vuetify.breakpoint.smAndDown}"
        >
          <span class="caption font-weight-medium">{{ btn_title }}</span>
        </tk-btn>
      </div>
      <div
        class="no-action"
        :class="{
        'no-action--mobile':$vuetify.breakpoint.smAndDown
        }"
        v-else-if="lift.title && noAction"
      >
        <h1
          v-if="title"
          class="no-action-title"
          v-html="title"
        />
        <p
          v-if="description"
          class="no-action-description"
          v-html="description"
        />
      </div>
    </base-card>
  </div>
</template>


<script>
import { getTranslation } from '../../components/base/Translation/Translation'

export default {
  props: [
    'lift',
    'height',
    'textRight',
    'sizes',
    'aspectRatio',
    'noAction',
    'textBoxColor'
  ],

  computed: {
    bannerMedia () {
      if (this.$vuetify.breakpoint.xsOnly) {
        return this.lift.mobile_media || {}
      }
      return this.lift.desktop_media || {}
    },

    title () {
      return this.getLocalizedText('title')
    },

    description () {
      return this.getLocalizedText('excerpt')
    },

    btn_title () {
      return this.getLocalizedText('btn_title')
    },
  },

  methods: {
    getLocalizedText (field) {
      return getTranslation(this.lift[field])
    },
  },
}
</script>
<style lang="scss">
.banner-inner {

  &-content {
    &--mobile {
      p {
        margin-bottom: 12px;
      }
    }
  }
}
</style>
<style
  lang="scss"
  scoped
>
$innerContentWidth: 100%;
$innerContentTopOffset: 0px;

.no-action {
  text-align: left;
  align-self: flex-end;
}
.no-action--mobile{
  padding-top: 24px;
  .no-action-title {
    font-size: 28px;
    text-align: center;
  }
  .no-action-description{
    font-size: 22px;
    text-align: center;
  }
}
.no-action-title {
  font-size: 46px;
  line-height: 3rem;
  margin-bottom: 12px;
}

.no-action-description {
  font-size: 2rem;
  line-height: 1.2;
  font-weight: 500;
  margin-bottom: 0;
}

.banner-container {
  position: relative;
  margin-bottom: $innerContentTopOffset;

  .v-card {
    &:hover {
      .v-btn {
        background-color: #8f8f8f !important;
      }
    }
  }

  @media only screen and (min-width: 960px) {
    margin-bottom: 0px;
  }

  .banner-inner {
    position: relative;
    top: $innerContentTopOffset;
    background-color: transparent;

    &--mobile-no-action{
      background-color: #000000;
      color: #ffffff;
    }

    &__btn {
      padding: 12px 32px;
      height: 38px;

      &--mobile {
        padding: 12px 32px;
        height: 38px;


        .caption {
          font-size: 12px !important;
          line-height: 16px !important;
        }
      }
    }

    &-content {
      max-width: $innerContentWidth;
      background-color: rgba($color: #ffffff, $alpha: 0.9);
      color: #000000;
      padding: 24px;
      position: static;
      width: 90%;

      h1 {
        font-size: 2.3rem;
        line-height: 100%;
      }

      &--mobile {
        width: 100%;
        padding: 12px;

        h1 {
          font-size: 26px;
          line-height: 32px;
        }
      }
    }

    // For desktop
    @media only screen and (min-width: 960px) {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);

      &-content {
        position: static;
        min-width: 350px;

        h1 {
          font-size: 32px;
          line-height: 38px;
        }
      }

      &--content-left {
        top: 50%;
        left: unset;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
